// extracted by mini-css-extract-plugin
module.exports = {"spinnerOverlay":"Spinner_spinnerOverlay__TzQHd","loader":"Spinner_loader__oqHD1"};